// extracted by mini-css-extract-plugin
export default {"TooltipV2":"TooltipV2_TooltipV2__QATID","TooltipV2__Show":"TooltipV2_TooltipV2__Show__76r3k"};